import styled from 'styled-components';
import { IonMenu } from '@ionic/react';

import { configs } from '$configs';
import { FONT, SPACE } from '$gstyles';

export const Wrapper = styled(IonMenu)`
  @media screen and (min-width: ${configs.display.desktopMinThreshold}) {
    --side-max-width: 200px;
    --side-min-width: 200px;
  }

  ion-content,
  ion-list,
  #background-content,
  ion-list-header,
  ion-item,
  button,
  ion-toolbar,
  div {
    border-color: var(--ion-color-base);
    --background: var(--ion-color-dark);
    color: var(--ion-color-base);
  }
  .list-md {
    background: var(--ion-color-dark);
    color: var(--ion-color-base);
  }
  ion-item.item ion-label,
  ion-item.item ion-icon {
    opacity: 0.8;
  }
  ion-item.item:hover {
    --background: rgba(255, 255, 255, 0.3);

    ion-label {
      color: var(--ion-color-base);
    }
  }
  ion-item.selected {
    --background: rgba(var(--ion-color-primary-rgb), 0.6);
  }

  ion-item ion-icon {
    margin-top: ${SPACE.MEDIUM};
    margin-bottom: ${SPACE.MEDIUM};
    margin-inline-end: ${SPACE.LARGE};
  }

  ion-item::part(native) {
    min-height: ${SPACE.LARGE};
    font-size: ${FONT.SMALL};
  }

  .logo {
    width: 190px;
    display: inline-block;
    padding: 16px 32px;
  }

  .app-version {
    display: inline-block;
    width: 40px;
    height: ${props => (props.isProd ? '14' : '28')}px;
    position: absolute;
    top: 50%;
    margin-top: -${props => (props.isProd ? '7' : '14')}px;
    right: ${SPACE.SMALL};
    font-size: 1.15rem;
    opacity: 0.5;

    > span {
      display: block;
    }
  }

  &.md {
    ion-content {
      --padding-start: ${SPACE.MEDIUM};
      --padding-end: ${SPACE.MEDIUM};
      --padding-top: ${SPACE.MEDIUM};
      --padding-bottom: ${SPACE.MEDIUM};
    }
    ion-note {
      padding-left: ${SPACE.MEDIUM};
    }
    ion-item {
      --padding-start: ${SPACE.MEDIUM};
      --padding-end: ${SPACE.MEDIUM};
      border-radius: 4px;
    }

    ion-item ion-icon {
      color: var(--ion-color-base);
    }

    ion-item ion-label {
      font-weight: 500;
    }
  }
`;
